import { getFallbackMessage } from '../translationsCache';
export class FallbackMissingPolicy {
    handle(sourceString, localeCode, params) {
        if ((process === null || process === void 0 ? void 0 : process.env.NEXT_PUBLIC_ENVIRONMENT_NAME) === 'local') {
            console.warn('Using fallback solution', { sourceString, localeCode });
        }
        return getFallbackMessage(sourceString, localeCode, params);
    }
}
//# sourceMappingURL=FallbackMissingPolicy.js.map